//dashboard widgets data
export const API_URL_PRD = 'https://innobobackend.azurewebsites.net/api';
export const API_URL_PRD_DOSAN = 'https://dosanbackend.azurewebsites.net/api';
export const API_URL_DEV = 'http://localhost:3005/api';

export const API_URL = API_URL_PRD;

//REGISTER
export const POST_FAKE_REGISTER = '/post-fake-register';

//LOGIN
export const POST_FAKE_LOGIN = '/post-fake-login';
export const POST_FAKE_JWT_LOGIN = '/post-jwt-login';
export const POST_FAKE_PASSWORD_FORGET = '/fake-forget-pwd';
export const POST_FAKE_JWT_PASSWORD_FORGET = '/jwt-forget-pwd';
export const SOCIAL_LOGIN = '/social-login';

//PROFILE
export const POST_EDIT_JWT_PROFILE = '/post-jwt-profile';
export const POST_EDIT_PROFILE = '/post-fake-profile';

//CONTACTS
// export const GET_USERS = "/users"
export const GET_USER_PROFILE = '/user';

//INVOICES
export const GET_INVOICES = 'http://localhost:3001/invoiceList';
export const GET_INVOICE_DETAIL = '/invoice';

//IFRAME Dashboard  Hollistics

export const embedCode_IFRAME = '97ef053616bf52488e1973cd';